export default __webpack_public_path__ + "static/media/defaultImage.05944a82.jpg";